/* Bugünkü Hedef — Plan vs Gerçek ilerleme kartı (Panel) */
import { useQuery } from "@tanstack/react-query";
import { Target } from "lucide-react";
import { api } from "@/lib/api";

export default function DailyTargetCard() {
  const { data } = useQuery({
    queryKey: ["daily-progress"],
    queryFn: api.planDailyProgress,
    refetchInterval: 30000,
  });
  if (!data || !data.daily_target_usd) return null;

  const pct = Math.max(0, Math.min(100, data.progress_pct || 0));
  const done = (data.progress_pct || 0) >= 100;
  const barColor = done ? "var(--up)" : pct >= 50 ? "var(--acc)" : "var(--gold)";

  return (
    <section
      data-testid="daily-target-card"
      style={{
        border: "1px solid var(--line)",
        borderRadius: 14,
        background: "var(--panel)",
        padding: "14px 18px",
        marginBottom: 18,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Target size={14} style={{ color: "var(--acc)" }} />
          <span style={{ fontSize: 13, fontWeight: 700 }}>Bugünkü Hedef</span>
          <span style={{ fontFamily: "var(--fm)", fontSize: 10, color: "var(--faint)" }}>
            {data.closed_trades_today} işlem kapandı (UTC)
          </span>
        </div>
        <div style={{ fontFamily: "var(--fm)", fontSize: 12 }} data-testid="daily-target-summary">
          <span style={{ color: data.realized_today >= 0 ? "var(--up)" : "var(--down)", fontWeight: 700 }}>
            ${data.realized_today.toFixed(2)}
          </span>
          <span style={{ color: "var(--faint)" }}> / ${data.daily_target_usd.toFixed(0)} </span>
          <b style={{ color: barColor }}>
            ({data.progress_pct != null ? `%${data.progress_pct.toFixed(0)}` : "—"})
          </b>
          {done && " 🎉"}
        </div>
      </div>
      <div
        style={{
          marginTop: 10,
          height: 8,
          borderRadius: 999,
          background: "rgba(255,255,255,0.06)",
          overflow: "hidden",
        }}
      >
        <div
          data-testid="daily-target-bar"
          style={{
            width: `${pct}%`,
            height: "100%",
            borderRadius: 999,
            background: barColor,
            boxShadow: `0 0 10px ${barColor}`,
            transition: "width .6s ease",
          }}
        />
      </div>
    </section>
  );
}
